import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { L10N_LOCALE, L10nLocale } from "angular-l10n";
import { AppConstants } from "../../../app.constants";
import { ActivatedRoute, Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Subscription } from "rxjs";
import { UserService } from "../../../services/user.service";
import { BusyIconService } from "../../../services/busy.service";

@Component({
  selector: "password-reset",
  styleUrls: ["../login.style.less"],
  templateUrl: "passwordReset.template.html",
  encapsulation: ViewEncapsulation.None
})
export class PasswordResetComponent implements OnInit {
  jwtHelper: JwtHelperService = new JwtHelperService();
  newPassword: string = "";
  confirmPassword: string = "";
  expiredToken: boolean = true;
  temporaryToken: string = "";

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private router: Router,
              private route: ActivatedRoute,
              private userService: UserService,
              private busyIconService: BusyIconService) {
    // -
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams["jwtToken"]) {
      this.temporaryToken = this.route.snapshot.queryParams["jwtToken"];
      const expired = this.jwtHelper.isTokenExpired(this.temporaryToken);
      if (expired) {
        this.expiredToken = true;
      } else {
        this.expiredToken = false;
      }
    }
  }

  public validatePasswordRegex(p) {
    const regex = new RegExp(AppConstants.PASSWORD_VALIDATION_REGEX);
    return regex.test(p);
  }

  savePassword() {
    let setNewPasswordTask: Subscription;
    setNewPasswordTask = this.userService.resetPassword(this.newPassword, this.confirmPassword, this.temporaryToken).subscribe(() => {
        this.newPassword = "";
        this.confirmPassword = "";
        this.backToLogin();
      }
    );
    this.busyIconService.showBusyIcon(setNewPasswordTask);

  }

  backToLogin() {
    this.router.navigate(["/login"]);
  }
}
